module.exports = __webpack_public_path__ + "static/img/ent-65.4ee0a22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-65.jpg
// module id = c5wN
// module chunks = 52